import { useAuth0 } from '@auth0/auth0-react'
import { Navigate, useLocation } from 'react-router'
import { useRole, type Role } from './role'

interface RequireRoleProps {
  role: Role | Role[]
  children: React.ReactNode
}

export function RequireRole({ role, children }: RequireRoleProps) {
  const { isAuthenticated, isLoading } = useAuth0()
  const userRole = useRole()
  const location = useLocation()

  if (isLoading) return null
  if (!isAuthenticated)
    return <Navigate to="/login" state={{ returnTo: location.pathname }} replace />

  const allowed = Array.isArray(role) ? role.includes(userRole as Role) : userRole === role
  if (!allowed) return <Navigate to="/unauthorized" replace />

  return <>{children}</>
}
